import { render } from "./ShroffDashboard.vue?vue&type=template&id=8a16519a&scoped=true"
import script from "./ShroffDashboard.vue?vue&type=script&lang=js"
export * from "./ShroffDashboard.vue?vue&type=script&lang=js"

import "./ShroffDashboard.vue?vue&type=style&index=0&id=8a16519a&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a16519a"]])

export default __exports__